import React from 'react';

const FooterUpsell = ({ caption, children, customStyles }) => (
  <section className="FooterUpsell textAlign-center">
    <div className="marginTop-16 marginLeft-16 marginRight-16 marginTop-32-m marginLeft-32-m marginRight-32-m marginBottom-32">
      <div className="FooterUpsell-image height-512 borderRadius-6 backgroundColor-grayLightest backgroundRepeat-noRepeat">
        <div className="paddingTop-64 paddingTop-128-l paddingLeft-16 paddingRight-16 paddingLeft-32-m paddingRight-32-m">
          {children}
        </div>
      </div>
      <p className="color-grayMedium text-2 marginTop-16">{caption}</p>
    </div>
  </section>
);

export default FooterUpsell;
